import {gql} from '@apollo/client';

const mutationRemoveMarker = gql`
    mutation removeMarker($marker_id: Float!){
        removeMarker(marker_id: $marker_id) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationUpdateMarker = gql`
    mutation updateMarker($session_code: String!, $marker_title: String!, $marker_start_at: String!, $marker_end_at: String, $marker_type: Float!, $user_id: Float!, $marker_id: Float){
        updateMarker(session_code: $session_code, marker_title: $marker_title, marker_start_at: $marker_start_at, marker_end_at: $marker_end_at, marker_type: $marker_type, user_id: $user_id, marker_id: $marker_id) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationExcludeParticipants = gql`
    mutation excludeParticipants($session_code: String!, $exclude: Boolean!, $identifier: [String!]!){
        excludeParticipants(session_code: $session_code, exclude: $exclude, identifier: $identifier) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationliveExperience = gql`
    mutation liveExperience($session_id: String!, $user_id: String!) {
        liveExperience(session_id: $session_id, user_id: $user_id ) {
        status
        messagecode
        message
        data
        }
    }
`;

const mutationCompleteExperience = gql`
    mutation completeExperience($session_id: String!, $user_id: String!) {
        completeExperience(session_id: $session_id, user_id: $user_id ) {
        status
        messagecode
        message
        data
        }
    }
`;

const mutationUpdateTrimTime = gql`
    mutation updateTrimTime($session_code: String!, $start_time: String!, $end_time: String!){
        updateTrimTime(session_code: $session_code, start_time: $start_time, end_time: $end_time) {
        session_id
        started_at
        ended_at
        }
        }
`;

const mutationUpdateCreatorOnboarding = gql`
    mutation updateCreatorOnboarding($preference_id: String!, $preference_name: String!, $preference_information: String!, $user_id: String!) {
        updateCreatorOnboarding(preference_id: $preference_id, preference_name: $preference_name, preference_information: $preference_information, user_id: $user_id) {
        status
        messagecode
        message
        data
        }
    }
`;

const mutationUpdateDepartment = gql`
    mutation updateDepartment($department_id: Float!, $department_alias: String!) {
        updateDepartment(department_id: $department_id, department_alias: $department_alias) {
            department_alias
        }
    }
`;

const mutationAddProject = gql`
    mutation addProject($cascadedProjectOrder: Float, $cascadedProjectId: Float, $projectOwnerId: Float!, $departmentId: Float!, $iconStimulusId: Float!, $backgroundStimulusId: Float, $tagCloud: JSON, $projectDescription: String, $projectName: String!, $projectAlias: String!) {
        addProject(cascadedProjectOrder: $cascadedProjectOrder, cascadedProjectId: $cascadedProjectId, projectOwnerId: $projectOwnerId, departmentId: $departmentId, iconStimulusId: $iconStimulusId, backgroundStimulusId: $backgroundStimulusId, tagCloud: $tagCloud, projectDescription: $projectDescription, projectName: $projectName, projectAlias: $projectAlias) {
        projectId
        projectAlias
        projectName
        projectDescription
        tagCloud
        deleted
        active
        createdAt
        updatedAt
        backgroundStimulusId
        iconStimulusId
        departmentId
        projectOwnerId
        cascadedProjectId
        createdBy
        updatedBy
        cascadedProjectOrder
        }
    }
`;

const mutationUpdateProject = gql`
    mutation updateProject($cascadedProjectOrder: Float, $cascadedProjectId: Float, $projectOwnerId: Float, $departmentId: Float, $iconStimulusId: Float, $backgroundStimulusId: Float, $tagCloud: JSON, $projectDescription: String, $projectName: String, $projectAlias: String, $projectId: Float!) {
        updateProject(cascadedProjectOrder: $cascadedProjectOrder, cascadedProjectId: $cascadedProjectId, projectOwnerId: $projectOwnerId, departmentId: $departmentId, iconStimulusId: $iconStimulusId, backgroundStimulusId: $backgroundStimulusId, tagCloud: $tagCloud, projectDescription: $projectDescription, projectName: $projectName, projectAlias: $projectAlias, projectId: $projectId) {
        projectId
        projectAlias
        projectName
        projectDescription
        tagCloud
        deleted
        active
        createdAt
        updatedAt
        backgroundStimulusId
        iconStimulusId
        departmentId
        projectOwnerId
        cascadedProjectId
        createdBy
        updatedBy
        cascadedProjectOrder
        }
    }
`;

const mutationDeleteProject = gql`
    mutation deleteProject($projectId: Float!) {
        deleteProject(projectId: $projectId) {
        status
        messagecode
        message
        data  
        }
    }
`;

const mutationAddProjectToExperience = gql`
    mutation addProjectToExperience($session_code: [String!]!, $project_id: [String!]!) {
        addProjectToExperience(session_code: $session_code, project_id: $project_id) {
            status
            messagecode
            message
            data  
        }
    }
`;

const mutationRemoveExperienceFromProject = gql`
    mutation removeExperienceFromProject($session_code: [String!]!, $project_id: [String!]!) {
        removeExperienceFromProject(session_code: $session_code, project_id: $project_id) {
            status
            messagecode
            message
            data  
        }
    }
`;

const mutationUpdateUserAttributes = gql`
    mutation updateUserAttributes($temporary_value: JSON, $metrics_value: String!, $user_id: String, $metrics_type: String) {
        updateUserAttributes(temporary_value: $temporary_value, metrics_value: $metrics_value, user_id: $user_id, metrics_type: $metrics_type) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationRemoveParticipants = gql`
    mutation removeParticipants($participants: [String!]!, $session_code: String!) {
        removeParticipants(participants: $participants, session_code: $session_code) {
            status
            messagecode
            message
            data  
        }
    }
`;

const mutationAddParticipants = gql`
  mutation addParticipants($session_id: Float!, $participants: [JSON!]!, $hubs: [JSON!]) {
    addParticipants(session_id: $session_id, participants: $participants, hubs: $hubs) {
      status
      messagecode
      message
      data
    }
  }
`;

const mutationAddTag = gql`
    mutation addTag($systemTag: Boolean!, $tagType: Float!, $department_id: String, $tagName: String!, $creatorUserId: Float!) {
        addTag(systemTag: $systemTag, tagType: $tagType, department_id: $department_id, tagName: $tagName, creatorUserId: $creatorUserId) {
            status
            messagecode
            message
            data  
        }
    }
`;

const mutationUpdateTag = gql`
    mutation updateTag($systemTag: Boolean!,$department_id: String, $tagType: Float!, $tagName: String!, $creatorUserId: Float!, $tagDescription:String, $tagId:Float!) {
        updateTag(systemTag: $systemTag,department_id: $department_id, tagType: $tagType, tagName: $tagName, creatorUserId: $creatorUserId, tagDescription: $tagDescription, tagId: $tagId) {
            status
            messagecode
            message
            data  
        }
    }
`;

const mutationUpdateTags = gql`
    mutation updateTags($tag_cloud: [JSON!], $participant_id: [Float!]!, $getPreviousTags: Boolean){
        updateTags(tag_cloud: $tag_cloud, participant_id: $participant_id,getPreviousTags:$getPreviousTags) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationDeleteTag = gql`
    mutation deleteTag($tagId:Float!,$user_id:String!) {
        deleteTag(tagId: $tagId,user_id: $user_id) {
            status
            messagecode
            message
            data  
        }
    }
`;

const mutationRemoveTags = gql`
    mutation removeTags($tag_cloud: [JSON!], $participant_id: [Float!]!){
        removeTags(tag_cloud: $tag_cloud, participant_id: $participant_id) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationUploadThumbnail = gql`
    mutation uploadThumbnail($session_code: String, $file: Upload!) {
        uploadThumbnail(session_code: $session_code, file: $file) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationAddParticipantsBysessionCode = gql`
    mutation addParticipantsBysessionCode($session_code: String!, $email: String!) {
        addParticipantsBysessionCode(session_code: $session_code, email: $email) {
            status
            message
        }
    }
`;

const mutationCancelExperience = gql`
    mutation cancelExperience($session_id: String!, $user_id: String!) {
        cancelExperience(session_id: $session_id, user_id: $user_id ) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationDeleteExperiences = gql`
    mutation deleteExperiences($session_code: [String!]!) {
        deleteExperiences(session_code: $session_code) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationRenameExperience = gql`
    mutation renameExperience($session_title: String!,$session_id: String!) {
        renameExperience(session_title: $session_title,session_id: $session_id) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationEditExperience = gql`
  mutation editExperience(
    $description: String!,
    $scheduled_end: String!,
    $scheduled_start: String!,
    $title: String!,
    $user_id: String!,
    $session_id: String!,
    $survey_link: String
  ) {
    editExperience(
      description: $description,
      scheduled_end: $scheduled_end,
      scheduled_start: $scheduled_start,
      title: $title,
      user_id: $user_id,
      session_id: $session_id,
      survey_link: $survey_link
    ) {
      status
      messagecode
      message
      data
    }
  }
`;

const mutationCreateExperience = gql`
  mutation createExperience(
    $session_origin: String,
    $using_hub_connectivity: Boolean,
    $disable_fingerpulse: Boolean,
    $description: String!,
    $duplicate_experience_id: Float,
    $scheduled_end: String!,
    $scheduled_start: String!,
    $title: String!,
    $user_id: String!,
    $agenda_json: JSON,
    $status: String!,
    $type: String!,
    $session_code: String!,
    $subcategory: String!,
    $participants: [JSON!]!,
    $category: String,
    $enable_watermark: Boolean,
    $enable_controls: Boolean,
    $surveylink: String,
    $braintrust_id: String,
    $braintrust_demo: Boolean,
    $hubs: [JSON!]
  ) {
    createExperience(
      session_origin: $session_origin
      using_hub_connectivity: $using_hub_connectivity
      disable_fingerpulse: $disable_fingerpulse
      duplicate_experience_id: $duplicate_experience_id
      description: $description,
      scheduled_end: $scheduled_end,
      scheduled_start: $scheduled_start,
      title: $title,
      user_id: $user_id,
      agenda_json: $agenda_json,
      status: $status,
      type: $type,
      session_code: $session_code,
      subcategory: $subcategory,
      participants: $participants,
      category: $category,
      enable_watermark: $enable_watermark,
      enable_controls: $enable_controls,
      surveylink: $surveylink,
      braintrust_id: $braintrust_id,
      braintrust_demo: $braintrust_demo,
      hubs: $hubs
    ) {
      status
      messagecode
      message
      data
    }
  }
`;

const mutationjoinSessionCode = gql`
  mutation joinSessionCode($session_code: String!, $identifier:String!, $temp_email: String!) {
    joinSessionCode(session_code: $session_code, temp_email: $temp_email, identifier: $identifier) {
      status
      message
      data
		}
	}
`;

const mutationcreateReelsExperience = gql`
  mutation createReelsExperience(
    $sessions: [JSON!],
    $reel_sessions: [Float!],
    $project_id: Float,
    $description: String!,
    $scheduled_end: String,
    $scheduled_start: String!,
    $title: String!,
    $user_id: String!,
    $agenda_json: JSON,
    $status: String!,
    $type: String!,
    $session_code: String!,
    $subcategory: String,
    $participants: [JSON!]!,
    $category: String,
    $enable_watermark: Boolean,
    $enable_controls: Boolean,
    $surveylink:String
  ) {
    createReelsExperience(
      sessions: $sessions,
      reel_sessions: $reel_sessions,
      project_id: $project_id,
      description: $description, 
      scheduled_end: $scheduled_end, 
      scheduled_start: $scheduled_start, 
      title: $title, 
      user_id: $user_id,
      agenda_json: $agenda_json, 
      status: $status, 
      type: $type, 
      session_code: $session_code, 
      subcategory: $subcategory, 
      participants: $participants, 
      category: $category,
      enable_watermark: $enable_watermark,
      enable_controls: $enable_controls,
      surveylink: $surveylink
    ) {
      status
      messagecode
      message
      data
    }
}`;

const mutationGetBraintrustList = gql`
    query getBraintrustList {
        getBraintrustList {
            status
            messagecode
            message
            data
        }
    }  
`;

const mutationmergeClip = gql`
    mutation mergeClip($user_id: Float!, $title:String, $clips_data: [JSON!]!) {
        mergeClip(user_id: $user_id, title:$title, clips_data: $clips_data) {
            status
            messagecode
            message
            data
            reels{
                session_id
            }
        }
    }
`;

const mutationReplaceParticipantsTags = gql`
  mutation replaceParticipantsTags($participants_data: [JSON!]!) {
    replaceParticipantsTags(participants_data: $participants_data) {
      status
      messagecode
      message
      data
    }
  }
`;

const mutationUpdateUserMetricValue = gql`
    mutation updateUserMertixValue($metrix_type: String!, $user_id: Float!, $metrix_value: JSON!) {
        updateUserMertixValue(metrix_type: $metrix_type, user_id: $user_id, metrix_value: $metrix_value) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationUrlEncodeConvert = gql`
    mutation urlEncodeConvert($url: [String!]!){
        urlEncodeConvert(url: $url)
    }
`;

const mutationEditSubCategory = gql`
  mutation editSubCategory($subcategory: String!, $category: String!, $session_id: Float!) {
    editSubCategory(subcategory: $subcategory, category: $category session_id: $session_id) {
      status
      message
      data
    }
  }
`;

const mutationAddRemoveStarExperience = gql`
  mutation addremoveStarExperience($department_id: Float, $star: Boolean!, $user_id: Float!, $sessions: [JSON!]!) {
    addremoveStarExperience(department_id: $department_id, star: $star, user_id: $user_id, sessions: $sessions) {
      status
      messagecode
      message
      data
    }
  }
`;
const mutationBenchmarkCompare = gql`
    mutation benchmarkCompareData($session_code: String!, $user_id: String!){
        benchmarkCompareData(session_code: $session_code, user_id: $user_id) {
            data
        }
    }
`;

export {
  mutationRemoveMarker,
  mutationUpdateMarker,
  mutationExcludeParticipants,
  mutationliveExperience,
  mutationCompleteExperience,
  mutationUpdateTrimTime,
  mutationUpdateCreatorOnboarding,
  mutationUpdateDepartment,
  mutationAddProject,
  mutationUpdateProject,
  mutationDeleteProject,
  mutationAddProjectToExperience,
  mutationRemoveExperienceFromProject,
  mutationUpdateUserAttributes,
  mutationRemoveParticipants,
  mutationAddParticipants,
  mutationAddTag,
  mutationUpdateTag,
  mutationUpdateTags,
  mutationDeleteTag,
  mutationRemoveTags,
  mutationUploadThumbnail,
  mutationAddParticipantsBysessionCode,
  mutationCancelExperience,
  mutationDeleteExperiences,
  mutationRenameExperience,
  mutationEditExperience,
  mutationCreateExperience,
  mutationjoinSessionCode,
  mutationcreateReelsExperience,
  mutationGetBraintrustList,
  mutationmergeClip,
  mutationReplaceParticipantsTags,
  mutationUrlEncodeConvert,
  mutationUpdateUserMetricValue,
  mutationEditSubCategory,
  mutationAddRemoveStarExperience,
  mutationBenchmarkCompare
};